import styles from "./journalcard.module.css";
import { AlertTriangle, Trash2, } from "react-feather";
import { Link } from "react-router-dom";
import dayjs from "dayjs";
import { useAuth0 } from "@auth0/auth0-react";

const JournalCard = ({ item, setDeleteId, setDeleteModalOpen }) => {
    const { user, isAuthenticated } = useAuth0();

    return (<Link to={"/security/journal/details/" + item?.id} className={`${styles.JournalListCard}`}>
        <div className={`${styles.JournalImageSec}`}>
            <p>{item?.user_initial}</p>
        </div>
        <div className={`${styles.JournalDesSec}`}>
            <p className={`${styles.Date}`}>{dayjs(item?.date).format("MM/DD/YYYY")} {item?.is_unusual === 1 && <AlertTriangle />}</p>
            <p className={`${styles.JournalTextSec}`}>{item?.user_name} <span>{item?.property_name}</span></p>
            <div className={`${styles.SummCommBodyText}`} dangerouslySetInnerHTML={{ __html: item.description }}></div>
        </div>
        {isAuthenticated && user["https://propertydek.com/permissions"].indexOf("journal:delete") > -1 && <button className={`${styles.DeleteJournalBU}`} onClick={(e) => { e.preventDefault(); e.stopPropagation(); setDeleteId(item?.id); setDeleteModalOpen(true); }}><Trash2 /></button>}
    </Link>);
};

export default JournalCard;